export const GetTidbitsActionTypes = {
  GET_TIDBITS_LOADING: "GET_TIDBITS_LOADING",
  GET_TIDBITS_ERROR: "GET_TIDBITS_ERROR",
  GET_TIDBITS_SUCCESS: "GET_TIDBITS_SUCCESS",
};
